import { createNamespacer, createReducer } from "../utils/reducers";
/**
 * Dashboard reducer: tracks current tab and selected entity ids
 * to coordinate dashboard views and detail panels.
 */

const initialState = {
  tab: "Objectives",
  initiativeId: null,
  objectiveId: null,
  keyResultId: null,
};

const namespacer = createNamespacer("DASHBOARD");

/** Action: set active dashboard tab. */
export const setDashboardTab = (value: string) => ({
  type: namespacer("SET_TAB"),
  payload: { value },
});

/** Action: set selected ids for initiative/objective/key result. */
export const setDashboardIds = (ids: {
  initiativeId: any;
  objectiveId: any;
  keyResultId: any;
}) => ({
  type: namespacer("SET_IDS"),
  payload: ids,
});

/** Action: clear all selected ids. */
export const resetDashboardIds = () => ({
  type: namespacer("RESET_IDS"),
});

const handlers = {
  [`${namespacer("SET_TAB")}`]: (state: any, action: any) => {
    return {
      ...state,
      tab: action.payload.value,
    };
  },
  [`${namespacer("SET_IDS")}`]: (state: any, action: any) => {
    return {
      ...state,
      initiativeId: action.payload.initiativeId,
      objectiveId: action.payload.objectiveId,
      keyResultId: action.payload.keyResultId,
    };
  },
  [`${namespacer("RESET_IDS")}`]: (state: any) => {
    return {
      ...state,
      initiativeId: null,
      objectiveId: null,
      keyResultId: null,
    };
  },
};

const dashboardReducer = createReducer(initialState, handlers, ["DASHBOARD"]);

export default dashboardReducer;
